import { GridCellProps } from '@progress/kendo-react-grid';
import { MouseEvent, useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import Button from 'src/components/design-system/Button';
import useViewDepartment from 'src/hooks/useViewDepartments';

const DepartmentEdit = (props: GridCellProps) => {
  const { setSelectedDepartment } = useViewDepartment();
  const {
    dataItem: { name, departmentId, isNewDepartmentName = false },
  } = props;

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      setSelectedDepartment({ departmentName: name, departmentId });
    },
    [departmentId, name, setSelectedDepartment]
  );

  return (
    <GridCellBase
      {...props}
      disableToolTip
      className="!text-center !p-0 relative"
      rowSelectionEnabled
    >
      {!isNewDepartmentName && (
        <Button
          color="secondary"
          onClick={handleClick}
          size="sm"
          className="absolute top-0 left-[50%] -translate-x-[50%] h-[24px] px-4 text-[12px]"
        >
          Edit
        </Button>
      )}
    </GridCellBase>
  );
};

export default DepartmentEdit;
